/**
 * Cutoff and delivery date, always in Phnom Penh time.
 *
 * This has to be server-authoritative. A phone in the wrong timezone, or a
 * customer who sets their clock back, must not be able to buy a place on a
 * truck that already left. Cambodia is a fixed UTC+7 with no daylight saving,
 * so the arithmetic is exact and needs no timezone database.
 */
export const ICT_OFFSET_MINUTES = 7 * 60;
/** Orders placed before this hour, Phnom Penh time, ride the same morning. */
export const CUTOFF_HOUR = 9;
function shift(now, minutes) {
    return new Date(now.getTime() + minutes * 60_000);
}
/** The wall clock in Phnom Penh, expressed as a UTC date for easy field reads. */
function ictClock(now) {
    return shift(now, ICT_OFFSET_MINUTES);
}
function isoDate(ict) {
    return ict.toISOString().slice(0, 10);
}
export function ictHour(now) {
    return ictClock(now).getUTCHours();
}
export function isBeforeCutoff(now, cutoffHour = CUTOFF_HOUR) {
    return ictHour(now) < cutoffHour;
}
export function slotFor(now, cutoffHour = CUTOFF_HOUR) {
    const ict = ictClock(now);
    const sameDay = ict.getUTCHours() < cutoffHour;
    const deliveryIct = sameDay ? ict : shift(ict, 24 * 60);
    // next cutoff instant, back in real UTC terms
    const cutoffIct = new Date(ict.getTime());
    cutoffIct.setUTCHours(cutoffHour, 0, 0, 0);
    if (!sameDay)
        cutoffIct.setUTCDate(cutoffIct.getUTCDate() + 1);
    return {
        deliveryDate: isoDate(deliveryIct),
        sameDay,
        msToCutoff: Math.max(0, cutoffIct.getTime() - ict.getTime()),
    };
}
/** hh:mm:ss remaining, for the countdown. Clamped at zero, never negative. */
export function formatCountdown(ms) {
    const total = Math.max(0, Math.floor(ms / 1000));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    const pad = (n) => String(n).padStart(2, "0");
    return `${pad(h)}:${pad(m)}:${pad(s)}`;
}
/**
 * A client may propose a delivery date; the server decides. Anything other
 * than the slot we would issue right now is rejected, which stops a stale tab
 * from booking yesterday.
 */
export function isAcceptableDeliveryDate(proposed, now, cutoffHour = CUTOFF_HOUR) {
    return proposed === slotFor(now, cutoffHour).deliveryDate;
}
//# sourceMappingURL=schedule.js.map